import React from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';

const tabs = [
  { to: 'submit', label: 'Submit Request', icon: 'bi-plus-circle' },
  { to: 'my-requests', label: 'My Requests', icon: 'bi-list-check' },
];

const ServiceRequestsLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (location.pathname.match(/\/service-requests\/?$/)) {
      navigate('submit', { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <>
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex align-items-center">
            <i className="bi bi-tools fs-2 text-warning me-3"></i>
            <div>
              <h1 className="h2 mb-1">Service Requests</h1>
              <p className="text-muted mb-0">Submit and track utility service requests and work orders</p>
            </div>
          </div>
        </div>
      </div>

      <div className="card border-0 shadow-sm mb-4">
        <div className="card-header bg-tse-primary text-white border-0">
          <div className="d-flex align-items-center">
            <i className="bi bi-lightning-charge me-2"></i>
            <span className="fw-bold">TriServe Energy</span>
            <span className="ms-2 opacity-75">Service Management</span>
          </div>
        </div>
        <div className="card-body p-0">
          <ul className="nav nav-tabs border-0" role="tablist" aria-label="Service request sections">
            {tabs.map((t) => {
              const isActive = location.pathname.endsWith(t.to);
              const tabId = `sr-tab-${t.to}`;
              const panelId = `sr-panel-${t.to}`;
              return (
                <li className="nav-item" role="presentation" key={t.to}>
                  <NavLink
                    id={tabId}
                    to={t.to}
                    className={({ isActive }) =>
                      'nav-link d-flex align-items-center px-4 py-3' + (isActive ? ' active' : '')
                    }
                    role="tab"
                    aria-selected={isActive}
                    aria-controls={panelId}
                    data-testid={tabId}
                  >
                    <i className={`bi ${t.icon} me-2`}></i>
                    {t.label}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <Outlet />
    </>
  );
};

export default ServiceRequestsLayout;
